import {ActivityCreate } from './ActivityCreate';
import { ActivityEdit } from './ActivityEdit';
import { ActivityList } from './ActivityList';

export default {
    // create: ActivityCreate,
    // edit: ActivityEdit,
    list: ActivityList
}